import { getAPI, postAPI, uploadApi } from "../api/api";
import { REACT_APP_COMMON } from "./common";
import mixpanelData, { userProfile } from "./mixpanel";


export const makeSideBarActive = (menu: { icon: string, title: string, url: string, active: boolean }[], index: number) => {
    menu.map((item) => item.active = false);
    menu[index].active = true;
    return menu
}

export const getMilliSec = (date: any) => {
  return new Date(date).getTime()
}

export const getMilliSecUTC = (date: any) => {
  let Adate = new Date(date)
  return  Date.UTC(Adate.getFullYear(),Adate.getMonth(),Adate.getDate())
 }

const today = new Date()

const profileMetadata = localStorage.getItem("profile_metadata") === null ? console.log('true') : JSON.parse(localStorage.getItem("profile_metadata") || "") || {}


export const findFilterDate = (value: number) => {
  
  switch (value) {
    case 1:
      return { from: new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000), to: today }
    case 2:
      return { from: new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000), to: today }
    case 3:
      return { from: new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000), to: today }
    case 4:
      return { from: new Date(today.getTime() - 180 * 24 * 60 * 60 * 1000), to: today }
    case 5:
      return { from: new Date(today.getTime() - 365 * 24 * 60 * 60 * 1000), to: today }
  }
}


export const convertMilliSecToDateNew = (date: any) => {
  if (date) {
      try 
      { return new Date(date).toDateString() }
      catch {
          return ''
      }
  } else {
      return ''
  }
}

export const checkCandidateStatus = (data: number| string) => {
  switch (data) {
    case 3:
      return { name: 'F2 - Full profile submitted', id: '3'}
    case 5:
      return { name: 'F3 - Verified', id: '5' }
    case 6:
      return { name: 'F99 - Rejected', id: '6' }
    case 7:
      return {name:'F100- Blacklisted',id:'7'}
  }
}

export const checkCandidateStatusMixpanel = (data: number| string) => {
  switch (data) {
    case 3:
      return 'F2 - Full profile submitted'
    case 5:
      return  'F3 - Verified'
    case 6:
      return 'F99 - Rejected'
    case 7:
      return 'F100- Blacklisted'
  }
}

export const checkSourcedBy = (data: string) => {
  switch (data) {
    case 'RECRUITER':
      return 'Recruiter'
    case 'PROVIDER':
      return 'Provider'
    case 'PROACTIVE':
      return 'Proactive'
    case 'CS-RECRUITER':
      return 'CS-Recruiter'
    case 'CUSTOMER':
      return 'Customer'
    case 'FREELANCER':
      return 'Freelancer'
    case 'SALES TEAM':
      return 'Sales team'
    case "Recruiter":
      return data
    default:
      return 'Not mentioned'
  }
}

export const checkFunctionality = (field:string,data: any) => {
  
  
  if (field === 'availabilityValue') {
   return checkAvailability(data,0)
  }

  if (field === 'priority'){
    return  checkPriority(data)
  }
  if(field === 'allocated_to'){
   return data
  }
  if(field === 'allocatedTo'){
      return data
  } 
}

export const submitMixPanel = (response: any) => {
  const data = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
  const skillsName = data.techStack.map((item: any) => { return (item.skill.skillName) })
  const jobRolesNames: string[] = data.jobRoles.map((item: {id: number, name: string}) => { return(item.name)})  
  const otherSkills: string[] = response.data[0].profile_metadata && response.data[0].profile_metadata.otherSkills.map((item: {skillId: number, skillName: string}) => { return(item.skillName)}) 
  let socailaProfile = []
    response.data[0].profile_metadata.linkedIn && socailaProfile.push({"linkedIn": response.data[0].profile_metadata.linkedIn}) 
    response.data[0].profile_metadata.github && socailaProfile.push({"github": response.data[0].profile_metadata.github}) 
    response.data[0].profile_metadata.stackoverflow && socailaProfile.push({"stackoverflow": response.data[0].profile_metadata.stackoverflow})  
  let certifications = response.data[0].profile_metadata && response.data[0].profile_metadata.ellowScreeningCertifications &&
                       response.data[0].profile_metadata.ellowScreeningCertifications.map((item: any) => {
                        return( item.skills.name)
                       })
  let locations = response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.locationPreference && response.data[0].profile_metadata.preference.locationPreference.location.map((item: any) => {
                    return item.name
                  })

    

  mixpanelData('TG - Full Profile Submitted', {
    'Source': 'Recruiter submits full profile',
    'Candidate Name': data && data.firstName,
    'candidate email': data && data.email,
    'distinct_id': localStorage.getItem('Email'),
    'Date': new Date().toDateString(),
    'ellow status': 'F3 - Verified',
    'Phone Number': data && data.phoneNumber,
    'skills': skillsName,
    'JobRoles': jobRolesNames,
    'candidateId': response.data[0].candidate_id,
    'prefered company type': response.data[0].profile_metadata && response.data[0].profile_metadata.preference.companyType && checkTypeofCompany(response.data[0].profile_metadata.preference.companyType),
    'designation': response.data[0].profile_metadata && response.data[0].profile_metadata.designation,
    'workExperience': data.workExperience,
    'prefered timeZone': response.data[0].profile_metadata && response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.timeZone && response.data[0].profile_metadata.preference.timeZone,
    'prefered location': response.data[0].profile_metadata && response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.locationPreference && checkWorkLocation(response.data[0].profile_metadata.preference.locationPreference.remoteType, response.data[0].profile_metadata.preference.locationPreference.location),
    'Work Type': response.data[0].profile_metadata.workType && checkWorkType(parseInt(response.data[0].profile_metadata.workType)),
    'Contract Type': response.data[0].profile_metadata.contractType && checkContractType(parseInt(response.data[0].profile_metadata.contractType.contractType)),
    'Availability': response.data[0].profile_metadata.availability && checkAvailabilityMixpanel(response.data[0].profile_metadata.availability.availabilityId, response.data[0].profile_metadata.availability.date),
    'prefered salary': response.data[0].profile_metadata.preference ? response.data[0].profile_metadata.preference.salary && response.data[0].profile_metadata.preference.salary.expectedPay + ' ' + response.data[0].profile_metadata.preference.salary.currencyType + ' ' + response.data[0].profile_metadata.preference.salary.billingType : 'Not Mentioned',
    'Career type': response.data[0].profile_metadata && response.data[0].profile_metadata.candidateWorkType,
    'level': response.data[0].profile_metadata && response.data[0].profile_metadata.assessmentLevel,
    'Source type': response.data[0].sourced_by,
    "resume name": response.data[0].profile_metadata && response.data[0].profile_metadata.resumeFileName,
    "github link": response.data[0].profile_metadata && response.data[0].profile_metadata.github,
    "linkedIn link": response.data[0].profile_metadata && response.data[0].profile_metadata.linkedIn,
    "stackoverflow link":  response.data[0].profile_metadata && response.data[0].profile_metadata.stackoverflow 

  })
  mixpanelData('New TG - Full Profile Submitted', {
    'Source': 'Recruiter submits a profile',
    'Candidate name': `${response.data[0].profile_metadata && response.data[0].profile_metadata.firstName} ${response.data[0].profile_metadata && response.data[0].profile_metadata.lastName}` ,
    'Candidate email': response.data[0].profile_metadata && response.data[0].profile_metadata.email,
    'Candidate loginid': response.data[0] && response.data[0].login_id,
    'distinct_id': localStorage.getItem('Email'),
    'Date': new Date().toDateString(),
    'Availability': response.data[0].profile_metadata.availability && checkAvailabilityMixpanel(response.data[0].profile_metadata.availability),
    'Contract type': response.data[0].profile_metadata.availability && checkContractType(parseInt(response.data[0].profile_metadata.contractType)),
    'Work type': checkWorkType(parseInt(response.data[0].profile_metadata.workType)),
    'ellow status': 'F3 - Verified',
    'Phone number': response.data[0].profile_metadata && response.data[0].profile_metadata.phoneNumber,
    'Skills': skillsName,
    'Job roles': jobRolesNames,
    'Social profile': socailaProfile,
    'Certifications': certifications,
    'Prefered company type': response.data[0].profile_metadata && response.data[0].profile_metadata.preference.companyType && checkTypeofCompany(response.data[0].profile_metadata.preference.companyType),
    'Designation': response.data[0].profile_metadata && response.data[0].profile_metadata.positionName,
    'Prefered location': response.data[0].profile_metadata && response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.locationPreference && checkWorkLocation(response.data[0].profile_metadata.preference.locationPreference.remoteType, response.data[0].profile_metadata.preference.locationPreference.location),
    'Location array': locations,
    'Prefered salary': response.data[0].profile_metadata.preference ? response.data[0].profile_metadata.preference.salary && response.data[0].profile_metadata.preference.salary.expectedPay + ' ' + response.data[0].profile_metadata.preference.salary.currencyType + ' ' + response.data[0].profile_metadata.preference.salary.billingType : 'Not Mentioned',
    'Career type': checkCareerType(parseInt(response.data[0].profile_metadata.workType)),
    'Level': response.data[0].profile_metadata && response.data[0].profile_metadata.assessmentLevel && checkLevel(response.data[0].profile_metadata.assessmentLevel)?.title,
    'Source type': response && response.data && response.data[0].sourced_by,
    'Source name': response && response.data && response.data[0].behalfOfName,
    "Resume name": response.data[0].profile_metadata && response.data[0].profile_metadata.resumeFileName,
    "Employee id": response && response.data[0] && response.data[0].employee_id,
    "Country": response.data[0].profile_metadata && response.data[0].profile_metadata.country,
    "Nationality": response.data[0].profile_metadata && response.data[0].profile_metadata.nationality,
    'Experience': response.data[0].profile_metadata && response.data[0].profile_metadata.workExperience + ' Years',
    'Other skills': otherSkills,
    'Job search criteria': response.data[0].profile_metadata && checkJobCriteria(parseInt(response.data[0].profile_metadata.jobSearchCriteria)),
    'Allocated to': response.data[0] && response.data[0].allocatedToUserName,  
    'Company type': response.data[0].profile_metadata && response.data[0].profile_metadata.preference && checkTypeofCompany(response.data[0].profile_metadata.preference.companyType),

  })
  mixpanelData('New TG - Resource Allocation', {
    'Source': 'Resource is allocated to recruiter who submited full profile',
    'Candidate name': response.data[0].profile_metadata && response.data[0].profile_metadata.firstName + ' ' + response.data[0].profile_metadata && response.data[0].profile_metadata.lastName ,
    'Candidate email': response.data[0].profile_metadata && response.data[0].profile_metadata.email,
    'Candidate loginid': response.data[0] && response.data[0].login_id,
    'distinct_id': localStorage.getItem('Email'),
    'Allocated to': localStorage.getItem('Email')
  })
  mixpanelData('New TG - Ellow status updated', {
    'Source': 'Recruiter changes status of a candidate',
    'Candidate name': `${response.data[0] && response.data[0].profile_metadata && response.data[0].profile_metadata.firstName} ${response.data[0].profile_metadata && response.data[0].profile_metadata.lastName}` ,
    'Candidate email': response.data[0].profile_metadata && response.data[0].profile_metadata.email,
    'Candidate loginid': response.data[0] && response.data[0].login_id,
    'distinct_id': localStorage.getItem('Email'),
    'ellow status': 'F3 - Verified',
    'Sourced by name': response && response.data[0] && response.data[0].behalfOfName,
    'Sourced by type': response && response.data[0].sourced_by,
    'Recruiter email': localStorage.getItem('Email'),
  })
  userProfile({
    'ellow status': 'F3 - Verified',
  }, response.data[0] && response.data[0].login_id)
}

export const checkTypeofCompany = (id: number) => {
  
  switch (id) {
    case 0:
      return 'A start-up'
    case 1:
      return 'A large company'
    case 2:
      return 'Both'
  }
}



export const checkPriority = (data: any) => {
  
  
  switch (data) {
    
    case '3':
      return 'Hot'
    
    case '2':
      return 'Warm'
    
    case '1':
      return 'Cold'

    case 3:
      return 'Hot'

    case 2:
      return 'Warm'
    
    case 1:
      return 'Cold'
     
  }
}

export const checkcompanySize = (data: number) => {
  switch (data) {
    case 0:
      return '1-10'
    case 1:
      return '11-50' 
    case 2:
      return '51-250'
    case 3:
      return '251-10k'
    case 4:
      return '10k+'
    
  }
}

export const checkRemote = (data: number) => {
  switch (data) {
    case 0:
      return 'Yes'
    case 1:
      return 'No'
 }

}

export const checkWorkLocation = (remoteType: number, location?: any) => {
  switch (remoteType) {
    case 0:
      return 'Remote Only'
    case 1:
      return 'Onsite at ' + (location && location.map((item: any) => item.name))
    case 2:
      return 'Hybrid at ' + (location && location.map((item: any) => item.name))
    case 3:
      return 'NA'
  }
}


export const availablityInFilter = (data: any) => {
      
  switch (data) {
    case 1: 
     return 'Immediately'
    case 2:    
      return 'Coming date'
    case 3:
      return 'Coming weeks'
    case 4:
      return 'Unavailable for jobs'
    case 5:
      return 'In Contract'
    default:
      return 'Not Mentioned'
  }
}





export const checkJobType = (data:number) => {
switch(data) {
  case 1: 
  return 'Freelancer'
   case 2:
   return 'Contract'
  case 3:
   return 'Full Time'
}

}

export const checkCompanyType = (data: number) => {
  switch (data) {
    case 1:
     return 'Hirer'

    case 2:
      return 'Provider'
    
    case 3:
      return 'Both'
      
  }
}

export const priorityClass = (data: number | string) => {
  
  switch (data) {
    
    case 1:
      return 'priorityLow'
    
    case 2:
      return 'priorityMedium'
    
    case 3:
      return 'priorityHigh'
    case '1':
      return 'priorityLow'
    
    case '2':
      return 'priorityMedium'
    
    case '3':
      return 'priorityHigh'

  }
}

export const checkActive = (status: number) => {
  switch (status) {
    case 4:
      return 'active'
    case 5:
      return 'danger'
    case 6:
      return 'danger'
    case 7:
      return 'danger'
  }
}

export const checkStatus = (status: number) => {
  switch (status) {
    case 7:
      return 'Enable'
    case 4:
      return 'Disable'
  }
}



export const calculateReportsCounts = (data: any) => {
  let value: any;
  
  let totalCandidates = data && data.length;
  let estimateSum = data && data.reduce(function (sum: any, current: any) {
    return sum + current.maximumPayableAmount;
  }, 0)
  let netPaySum = data && data.reduce(function (sum: any, current: any) {
    return sum + current.candidateOverallPay;
  }, 0)
  let differenceSum = data && data.reduce(function (sum: any, current: any) {
    return sum + current.difference;
  }, 0)
  let maximumSum = data && data.reduce(function (sum: any, current: any) {
    return sum + current.maximumBillingAmount;
  }, 0)
  let estimateInvoiceSum = data && data.reduce(function (sum: any, current: any) {
    return sum + current.estimatedInvoiceAmount;
  }, 0)
  let actualInvoicesum = data && data.reduce(function (sum: any, current: any) {
    return sum + current.actualInvoiceAmount;
  }, 0)
  
  value = {
    totalCandidates,
    estimateSum,
    netPaySum,
    differenceSum,
    maximumSum,
    estimateInvoiceSum,
    actualInvoicesum
  }

  return value
}


export const checkSize = (size: number) => {
  switch (size) {
    case 0:
      return { id: 0, name: '1-10' }
    case 1:
      return { id: 1, name: '11-50' }
    case 2:
      return { id: 2, name: '51-250' }
    case 3:
      return { id: 3, name: '251-10k' }
    case 4:
      return { id: 4, name: '10k+' }
}
}

export const timeSince = (date: any) => {
  let d: any = new Date(+date);
  let val: any = new Date()
  let seconds = Math.floor((val - d) / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
      return Math.floor(interval) === 1 ? Math.floor(interval) + ' year ago' : Math.floor(interval) + " Years ago";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
      return Math.floor(interval) === 1 ? Math.floor(interval) + ' month ago' : Math.floor(interval) + " months ago";
  }
  interval = seconds / 86400;
  if (interval > 1) {
      return Math.floor(interval) === 1 ? Math.floor(interval) + ' day ago' : Math.floor(interval) + " days ago";
  }
  interval = seconds / 3600;
  if (interval > 1) {
      return Math.floor(interval) === 1 ? Math.floor(interval) + ' hour ago' : Math.floor(interval) + " hours ago";
  }
  interval = seconds / 60;
  if (interval > 1) {
      return Math.floor(interval) === 1 ? Math.floor(interval) + ' minute ago' : Math.floor(interval) + " minutes ago";
  }
  return Math.floor(interval) === 1 ? Math.floor(seconds) + ' second ago' : Math.floor(seconds) + " seconds ago";
}

var a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ',
    'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
var b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];


export const inWords = (num:any) => {
  if ((num = num.toString()).length > 9) return 'Limit Exceeds';
  let n:any = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return; var str = '';
  str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
  str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
  str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
  str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
  str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only! ' : '';
  return str;
}

export const workexperience = (value: number, type: number) => {
  let data = value.toString()
  return data.split('.')[type] || 0
}

export const checkPositionStatus = (value: number) => {
  switch (value) {
    case 1:
      return 'Submitted to Hirer'
    case 2:
      return 'Shortlisted'
    case 3:
      return 'Rejected by Hirer'
    case 4:
      return 'Canidate Interview'
    case 5:
      return 'Resource Accepted Offer'
    case 6:
      return 'Resource Rejected Offer'
    case 7:
      return 'Ellow Rejected Offer'
    case 8:
      return 'Unavailable'
  }
}

export const checkLevel = (level: number) => {
  switch (level) {
    case 1:
      return {
        title: 'Level 1 Developer',
        summary: 'A person with coding and unit testing experience'
      }
    case 2:
      return {
        title: 'Level 2 Developer',
        summary: 'A person with experience in designing along with coding and testing and can perform code reviews with ease.'
      }
      case 3:
        return {
          title: 'Level 3 Developer',
          summary: 'A person experienced in Designing, code reviewing, and mentoring junior developers'
      }
      case 4:
        return {
          title: 'Level 4 Developer',
          summary: 'A person experienced in Managing the team and assigning tasks along with excellent designing and coding skills.'
        }
  }
}

export const mixpanelEvents = (data: any, type: string) => { 
  switch (type) {
    case 'Personal Details':
      mixpanelData('TG - Personal Details updated',{
        'source': 'Recruiter submits personal details of a candidate',
        'country': data.profile_metadata.country,
        'email': data.profile_metadata.email,
        'Name': data.profile_metadata.firstName + " " + data.profile_metadata.lastName,
        'linkedIn': data.profile_metadata.linkedIn,
        'nationality': data.profile_metadata.nationality,
        'phoneNumber': data.profile_metadata.phoneNumber,
        'distinct_id': localStorage.getItem('Email'),
        'Recruiter email': localStorage.getItem('Email')
      })
      let socailaProfile = []
      data.profile_metadata.linkedIn && socailaProfile.push({"linkedIn": data.profile_metadata.linkedIn}) 
      data.profile_metadata.github && socailaProfile.push({"github": data.profile_metadata.github}) 
      data.profile_metadata.stackoverflow && socailaProfile.push({"stackoverflow": data.profile_metadata.stackoverflow}) 
      
      mixpanelData('New TG - Personal Details updated',{
        'source': 'Recruiter submits personal details of a candidate',
        'Country': data.profile_metadata.country,
        'Candidate email': data.profile_metadata.email,
        'Name': data.profile_metadata.firstName + " " + data.profile_metadata.lastName,
        'Social profile': socailaProfile,
        'Nationality': data.profile_metadata.nationality,
        'Phone number': data.profile_metadata.phoneNumber,
        'distinct_id': localStorage.getItem('Email'),
        'Candidate loginid': data.login_id,
        'Recruiter email': localStorage.getItem('Email')
      })
      break
    case 'Skills':        
      mixpanelData('TG - Skills updated', {
        'source': 'Recruiter submits skills of a candidate',
        'jobRoles': data.profile_metadata.jobRoles && data.profile_metadata.jobRoles.map((item: any) => item.name),
        'positionName': data.profile_metadata.positionName,
        'skills': data.profile_metadata.techStack && data.profile_metadata.techStack.map((item: any) => item.skill && item.skill.skillName),
        'distinct_id': localStorage.getItem('Email'),
        'workExperience': data.profile_metadata.workExperience,
        'Recruiter email': localStorage.getItem('Email'),
        'otherSkills': data.profile_metadata.otherSkills && data.profile_metadata.otherSkills.length > 0 && data.profile_metadata.otherSkills.map((item: any) => item.skillName),
      })
      mixpanelData('New TG - Skills updated', {
        'source': 'Recruiter submits skills of a candidate',
        'Job role': data.profile_metadata.jobRoles && data.profile_metadata.jobRoles.map((item: any) => item.name),
        'Designation': data.profile_metadata.positionName,
        'Skills': data.profile_metadata.techStack && data.profile_metadata.techStack.map((item: any) => item.skill && item.skill.skillName),
        'distinct_id': localStorage.getItem('Email'),
        'Work experience': data.profile_metadata.workExperience + ' Years',
        'Recruiter email': localStorage.getItem('Email'),
        'Other skills': data.profile_metadata.otherSkills && data.profile_metadata.otherSkills.length > 0 && data.profile_metadata.otherSkills.map((item: any) => item.skillName),
        'Candidate loginid': data.login_id,
        'Candidate email': data.profile_metadata.email,
        'Name': data.profile_metadata.firstName + " " + data.profile_metadata.lastName,
      })
      break
    case 'Availability':
      mixpanelData('TG - Avaialblity Submitted', {
        'source': 'Recruiter changes Availablity',
        'distinct_id': localStorage.getItem('Email'),
        'Candidate loginid': data.login_id,
        'Candidate email': data.profile_metadata.email,
        'Name': data.profile_metadata.firstName + " " + data.profile_metadata.lastName,
        'availability': checkAvailabilityMixpanel(data.profile_metadata.availability && data.profile_metadata.availability)
      })
      mixpanelData('New TG - Availability Updated', {
        'source': 'Recruiter changes Availability',
        'distinct_id': localStorage.getItem('Email'),
        'Candidate loginid': data.login_id,
        'Candidate email': data.profile_metadata.email,
        'Candidate name': data.profile_metadata.firstName + " " + data.profile_metadata.lastName,
        'Availability': checkAvailabilityMixpanel(data.profile_metadata.availability && data.profile_metadata.availability),
        'Contract type': checkContractType(parseInt(data.profile_metadata.contractType)),
        'Work type': checkWorkType(parseInt(data.profile_metadata.workType)),
        'Job search criteria': checkJobCriteria(parseInt(data.profile_metadata && data.profile_metadata.jobSearchCriteria))
      })
      break
    case 'Preferences':
        mixpanelData('TG - Preference updated', {
          'source': 'Recruiter submit preference',
          // 'Company Type': data.profile_metadata.preference && checkCompanyType(data.profile_metadata.preference.companyType),
          'Expected Pay': data.profile_metadata.preference && data.profile_metadata.preference.salary && data.profile_metadata.preference.salary.expectedPay,
          'Billing Type': data.profile_metadata.preference && data.profile_metadata.preference.salary && data.profile_metadata.preference.salary.billingType,
          'Currency Type': data.profile_metadata.preference && data.profile_metadata.preference.salary && data.profile_metadata.preference.salary.currencyType,
          'Time Zone': data.profile_metadata.preference && data.profile_metadata.preference.timeZone && data.profile_metadata.preference.timeZone,
          'distinct_id': localStorage.getItem('Email'),
        })
        mixpanelData('New TG - Preference updated', {
          'source': 'Recruiter submit preference',
          'Expected salary': `${data.profile_metadata.preference && data.profile_metadata.preference.salary && data.profile_metadata.preference.salary.expectedPay} ${data.profile_metadata.preference && data.profile_metadata.preference.salary && data.profile_metadata.preference.salary.currencyType} / ${data.profile_metadata.preference && data.profile_metadata.preference.salary && data.profile_metadata.preference.salary.billingType}` ,
          'Time Zone': data.profile_metadata.preference && data.profile_metadata.preference.timeZone && data.profile_metadata.preference.timeZone,
          'distinct_id': localStorage.getItem('Email'),
          'Candidate loginid': data.login_id,
          'Candidate email': data.profile_metadata.email,
          'Candidate name': data.profile_metadata.firstName + " " + data.profile_metadata.lastName,
          'Availability': checkAvailabilityMixpanel(data.profile_metadata.availability && data.profile_metadata.availability),
          'Preferred work location': checkWorkLocation(data.profile_metadata.preference.locationPreference.remoteType, data.profile_metadata.preference.locationPreference.location),
          'Location array': data.profile_metadata.preference && data.profile_metadata.preference.locationPreference && data.profile_metadata.preference.locationPreference.location.map((item: any) => {return item.name}),
          'Preferred company': data.profile_metadata.preference && data.profile_metadata.preference.companyType && checkTypeofCompany(data.profile_metadata.preference.companyType)
        })
      break

  }
}

export const checkWorkType = (data: number | undefined) => {
  switch (data) {
    case 1: 
     return 'Contract'
    case 2:
      return 'Permanent full time employee'
    case 3:
      return 'Open for both'
  }
}

export const checkCareerType = (data: number | undefined) => {
  switch (data) {
    case 1: 
     return 'Career Freelancers'
    case 2:
      return 'Full time employee'
    case 3:
      return 'Open for both'
  }
}
export async function getSkills() {
  const details = getAPI(REACT_APP_COMMON + '/skills')
  return details
}


export const skillNameConverter = (data: any) => {

  let value = data.map((item: any) => {
    let response = {
      skillId: item.id,
      skillName: item.name
    }
    return response
  })
  return value
}

export const checkContractType = (data: number | undefined) => {
  switch (data) {
    case 1: 
     return 'I’m available for 8hrs/day,40hrs/week'
    case 2:
      return 'I can start part-time immediately and then switch to full-time later on'
    case 3:
      return 'No, I’m not interested in remote work'
  }
}

export const checkAvailability = (data: any, date?: number | Date | undefined) => {
  switch (data && data.availability) {
    case 1: 
     return 'Immediately'
    case 2:    
      let newDate :any = data.availability_date ? new Date(parseInt(data.availability_date)).toDateString().slice(3) : 'coming date'    
      return `I’m getting relieved from my current job by ${newDate}`
    case 3:
      let weeks: any = data.availability_week ? data.availability_week : 'coming'
      return `In ${weeks} weeks after I get the offer`
    case 4:
      return 'Unavailable for jobs'
    case 5:
      let startDate: any = data.contractStartDate ? new Date(parseInt(data.contractStartDate)).toDateString().slice(3) : 'NA'
      let endDate:any = data.contractEndDate ? new Date(parseInt(data.contractEndDate)).toDateString().slice(3) : 'NA'
      return `In Contract(${startDate} - ${endDate})`
    case 6:
      return 'Fulltime'
    default:
      return 'Not Mentioned'
  }
}

export const checkEmail = () => {
  const Email = localStorage.getItem('Email')
  if (Email === 'jishap@ellow.io' || Email === 'sariga@ellow.io' || Email === 'mahesh.rn@ellow.io' || Email === 'jjoseph@ellow.io' || Email === 'aparna.vuke@ellow.io' || Email === 'vismaya.manoj@ellow.io') {
   return true
  }
  else { 
    return false
  }
}

export const companyApprovalAccess = (companyType: any) => {
  
  const Email = localStorage.getItem('Email')
  if(companyType === 1){
    if (Email === 'jjoseph@ellow.io' || Email === 'vismaya.manoj@ellow.io' || Email === 'aparna.vuke@ellow.io' || Email === 'varun.v@ellow.io') {
      return true
     }
     else { 
       return false
     }
  }
  if(companyType === 2){
    if (Email === 'jjoseph@ellow.io' || Email === 'vismaya.manoj@ellow.io' || Email === 'george.alex@ellow.io' || Email === 'aparna.vuke@ellow.io') {
      return true
     }
     else { 
       return false
     }
  }
  
}

export const checkAvailabilityMixpanel = (data: any, date?: number | Date | undefined) => { 
   
  switch (data && data.availabilityId) {
    case 1: 
     return 'Immediately'
    case 2:    
      let newDate :any = data.date ? new Date(parseInt(data.date)).toDateString().slice(3) : 'coming date'    
      return `I’m getting relieved from my current job by ${newDate}`
    case 3:
      let weeks: any = data.weeks ? data.weeks : 'coming'
      return `In ${weeks} weeks after I get the offer`
    case 4:
      return 'Unavailable for jobs'
    case 5:
      let startDate: any = data.contractStartDate ? new Date(parseInt(data.contractStartDate)).toDateString().slice(3) : 'NA'
      let endDate:any = data.contractEndDate ? new Date(parseInt(data.contractEndDate)).toDateString().slice(3) : 'NA'
      return `In Contract(${startDate} - ${endDate})`
    default:
      return 'Not Mentioned'
  }
}

export const checkJobCriteria = (type: number) => {
  switch (type) {
    case 1:
      return 'Ready to work'
    case 2:
      return 'Ready to hear'
    case 3:
      return 'Not ready yet'
}
}




export const checkTimesheetStatus = (status: string) => {
  switch (status) {
    case '1':
      return {
        value: 'Draft',
        class: 'statusMessage Yellow'
      }
    case '2':
      return {
        value: 'Submitted',
        class: 'statusMessage Yellow'
      }
    case '3':
      return {
        value: 'Approved',
        class: 'statusMessage Green'
      }
    case '4':
      return {
        value: 'Rejected',
        class: 'statusMessage Red'
    }
    default:
      return {
        value: '',
        class: ''
    }
  }
}

export const checkHrEmail = () => {
  const Email = localStorage.getItem('Email')
  if (Email === 'jishap@ellow.io' || Email === 'sariga@ellow.io' || Email === 'vismaya.manoj@ellow.io' || Email === 'varun.v@ellow.io' || Email === 'roopa.nambiar@ellow.io' || Email === 'ria.jacob@ellow.io' || Email === 'nidhin.babu@ellow.io' || Email === 'jithin.us@ellow.io' || Email === 'aparna.vuke@ellow.io' || Email === 'clint.thomas@ellow.io') {
   return true
  }
  else { 
    return false
  }
}

export const timesheetCsvHeader = [
  { label: "Employee ID", key: "employeeId" },
  { label: "Candidate Name", key: "candidateName" },
  { label: "Client", key: "companyName" },
  { label: "Contract Start Date", key: "newContractStartDate" },
  { label: "Contract End Date", key: "newContractEndDate" },
  { label: "Contract Type", key: "contractType" },
  { label: "Timesheet received date", key: "newSubmittedOn" },
  { label: "Time sheet Submitted", key: "status" },
  { label: "Time sheet Approved", key: "status" },
  { label: "Actual Candidate Rate", key: "resourceCost" },
  { label: "Candidate Estimated pay", key: "maximumPayableAmount" },
  { label: "Leaves", key: "leaves" },
  { label: "No of Holidays", key: "holidays" },
  { label: "Actual Number of Working Days", key: "actualWorkingDays" },
  { label: "Payable working days", key: "payableWorkingDays" },
  { label: "Working Days in the Month", key: "totalWorkingDays" },
  { label: "Candidate arrears", key: "totalArrearsCandidate" },
  { label: "Candidate deductions", key: "totalDeductionsCandidate" },
  { label: "Salary Payable", key: "candidate_adjusted_overall_payment" },
  { label: "GST Rate", key: "gstPercentageCandidate" },
  { label: "GST", key: "gstAmountCandidate" },
  { label: "TDS", key: "tdsAmountCandidate" },
  { label: "Net Salary", key: "candidatePay" },
  { label: "Individual/Service Provider", key: "candidateType" },
  { label: "Type of Billing", key: "billingType" },
  { label: "Billing Rate", key: "billingRate" },
  { label: "Client Estimate", key: "maximumBillingAmount" },
  { label: "Customer arrears", key: "totalArrearsCustomer" },
  { label: "Customer deductions", key: "totalDeductionsCustomer" },
  { label: "Actual Invoice amount", key: "customer_adjusted_overall_payment" },
  { label: "Total Invoice amount", key: "customerBill" },
]

export const nameConversion = (name: string) => {
  //   let data = name.charAt(0).toUpperCase() + name.slice(1);
  const arr = name.split(" ");
  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  const data = arr.join(" ");
  return data;
}

export const checkUserActiveStatus = (status: number) => {
  switch (status) {
    case 1:
      return 'Basic Registration'
    case 2:
      return 'Full Registration'
    case 3:
      return 'Call scheduled'
    case 4:
      return 'Approved'
    case 5:
      return 'Rejected'
    case 6:
      return 'Disabled as company is rejected'
    case 7:
      return 'Disabled'
    case 8:
      return 'Deleted'
  }
}




